import AppError from '../../../../../utilities/app-error';
import { authApi, templateApi } from '../../../../../utilities/axios';

const REPORT_URL = process.env.VUE_APP_API_VERSION + '/report';
// Base URL already setup in axios templateAPI
const TEMPLATE_URL = '/v2';

class ReportService {
    // =======> Task Report Section Starts here

    async fetchTaskReport(params) {
        // try {
        return await authApi.post(`${REPORT_URL}/task/dynamic`, params);
        // } catch (error) {
        //     throw new AppError(error.status, `Failed to fetch data for task report`);
        // }
    }

    async fetchDebriefReport(params) {
        // return await authApi.post(`${REPORT_URL}/debrief/dynamic`, params);
        return await authApi.post(`${REPORT_URL}/debrief/dynamic`, params);
    }

    async downloadTemplateReport(templateId, templateJson) {
        try {
            return await templateApi.post(`${TEMPLATE_URL}/create-pdf`, templateJson, {
                params: {
                    template_id: templateId,
                },
            });
        } catch (error) {
            throw new AppError(error.status, `Failed to download template report`);
        }
    }
}

export default new ReportService();
